/** Shared Projects/editor rename validation. Names remain user-visible storage keys. */
export function projectRenameError(
  name: string,
  oldName: string,
  savedNames: readonly string[],
): string {
  if (!name.trim()) return 'Enter a project name.';
  if (name.trim() !== oldName && savedNames.includes(name.trim()))
    return 'A project with this name already exists.';
  return '';
}
